import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CATEGORY_COLORS = ['#FF6B00', '#3B82F6', '#10B981'];
const AGE_COLORS = ['#FF6B00', '#F59E0B', '#10B981', '#3B82F6'];
const DISTRICT_COLORS = ['#FF6B00', '#F59E0B', '#10B981', '#3B82F6', '#8B5CF6', '#EC4899', '#14B8A6', '#F97316', '#6366F1', '#84CC16'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// ── Feedback Tab ──────────────────────────────────────────────
function FeedbackTab({ token }) {
    const [feedbacks, setFeedbacks] = useState([]);

    useEffect(() => {
        fetch('http://localhost:5000/api/dashboard/feedbacks', {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => setFeedbacks(Array.isArray(data) ? data : []));
    }, [token]);

    const deleteFeedback = async (id) => {
        if (!window.confirm('Kya aap ye feedback delete karna chahte hain?')) return;
        try {
            await fetch(`http://localhost:5000/api/dashboard/feedbacks/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setFeedbacks(prev => prev.filter(f => f.id !== id));
        } catch (err) {
            alert('Delete nahi hua. Dobara try karo.');
        }
    };

    const stars = (rating) => '★'.repeat(rating) + '☆'.repeat(5 - rating);

    return (
        <div className="bg-dark-200 border border-gray-800 rounded-2xl overflow-hidden">
            <table className="w-full text-sm">
                <thead>
                    <tr className="border-b border-gray-800">
                        <th className="text-gray-400 font-medium text-left px-6 py-4">#</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Name</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Rating</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Message</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Date</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {feedbacks.length === 0 ? (
                        <tr><td colSpan="6" className="text-center text-gray-500 py-10">Koi feedback nahi mila</td></tr>
                    ) : (
                        feedbacks.map((f, i) => (
                            <tr key={f.id} className="border-b border-gray-800 hover:bg-dark-300 transition">
                                <td className="px-6 py-4 text-gray-500">{i + 1}</td>
                                <td className="px-6 py-4 text-white font-medium">{f.name || 'Anonymous'}</td>
                                <td className="px-6 py-4 text-saffron-500 text-lg">{stars(f.rating)}</td>
                                <td className="px-6 py-4 text-gray-400">{f.message || '—'}</td>
                                <td className="px-6 py-4 text-gray-500">{new Date(f.created_at).toLocaleDateString('en-IN')}</td>
                                <td className="px-6 py-4">
                                    <button
                                        onClick={() => deleteFeedback(f.id)}
                                        className="bg-red-500/20 hover:bg-red-500/40 text-red-400 text-xs px-3 py-1 rounded-full transition"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}
// ── Contacts Tab ──────────────────────────────────────────────
function ContactsTab({ token }) {
    const [contacts, setContacts] = useState([]);

    useEffect(() => {
        fetch('http://localhost:5000/api/dashboard/contacts', {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => setContacts(Array.isArray(data) ? data : []));
    }, [token]);

    const deleteContact = async (id) => {
        if (!window.confirm('Kya aap ye contact delete karna chahte hain?')) return;
        try {
            await fetch(`http://localhost:5000/api/dashboard/contacts/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setContacts(prev => prev.filter(c => c.id !== id));
        } catch (err) {
            alert('Delete nahi hua. Dobara try karo.');
        }
    };

    return (
        <div className="bg-dark-200 border border-gray-800 rounded-2xl overflow-hidden">
            <table className="w-full text-sm">
                <thead>
                    <tr className="border-b border-gray-800">
                        <th className="text-gray-400 font-medium text-left px-6 py-4">#</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Name</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Phone</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Email</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Message</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Date</th>
                        <th className="text-gray-400 font-medium text-left px-6 py-4">Action</th>
                        <th className="text-gray-400 font-medium text-left px-4 py-4">Joining</th>
                    </tr>
                </thead>
                <tbody>
                    {contacts.length === 0 ? (
                        <tr><td colSpan="7" className="text-center text-gray-500 py-10">Koi contact nahi mila</td></tr>
                    ) : (
                        contacts.map((c, i) => (
                            <tr key={c.id} className="border-b border-gray-800 hover:bg-dark-300 transition">
                                <td className="px-6 py-4 text-gray-500">{i + 1}</td>
                                <td className="px-6 py-4 text-white font-medium">{c.name}</td>
                                <td className="px-6 py-4 text-gray-400">{c.phone}</td>
                                <td className="px-6 py-4 text-gray-400">{c.email || '—'}</td>
                                <td className="px-6 py-4 text-gray-400">{c.message}</td>
                                <td className="px-6 py-4 text-gray-500">{new Date(c.created_at).toLocaleDateString('en-IN')}</td>
                                <td className="px-6 py-4">
                                    <button
                                        onClick={() => deleteContact(c.id)}
                                        className="bg-red-500/20 hover:bg-red-500/40 text-red-400 text-xs px-3 py-1 rounded-full transition"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}
// ── Main Dashboard ────────────────────────────────────────────
function AdminDashboard() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('overview');
    const [filterQualification, setFilterQualification] = useState('all');
    const [filterExperience, setFilterExperience] = useState('all');
    const [filterDistrict, setFilterDistrict] = useState('all');
    const [filterAge, setFilterAge] = useState('all');
    const [filterBranch, setFilterBranch] = useState('all');
    const [filterMonth, setFilterMonth] = useState('all');
    const [filterJoining, setFilterJoining] = useState('all');
    const [totalStudents, setTotalStudents] = useState(0);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [thisMonth, setThisMonth] = useState(0);
    const [lastMonth, setLastMonth] = useState(0);
    const [categoryData, setCategoryData] = useState([]);
    const [ageData, setAgeData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [students, setStudents] = useState([]);

    const fetchStats = async () => {
        try {
            const token = localStorage.getItem('adminToken');
            const res = await fetch('http://localhost:5000/api/dashboard/stats', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.categoryStats) {
                setCategoryData(data.categoryStats.map((s, i) => ({
                    name: s.category === '10th' ? '10th/12th/Grad' : s.category.toUpperCase(),
                    value: Number(s.count),
                    color: CATEGORY_COLORS[i] || '#FF6B00',
                })));
                setAgeData(data.ageStats.map((s, i) => ({
                    name: s.age_group,
                    value: Number(s.count),
                    color: AGE_COLORS[i] || '#FF6B00',
                })));
                setDistrictData(data.districtStats.map((s, i) => ({
                    name: s.district,
                    value: Number(s.count),
                    color: DISTRICT_COLORS[i] || '#FF6B00',
                })));
                setTotalStudents(data.total);
                setTotalRevenue(data.revenue);
                setThisMonth(data.thisMonth);
                setLastMonth(data.lastMonth);
            }
        } catch (err) {
            console.error('Stats fetch error:', err);
        }
    };

    const fetchStudents = async () => {
        try {
            const token = localStorage.getItem('adminToken');
            let url = 'http://localhost:5000/api/dashboard/students?';

            if (filterQualification === '10th') { url += 'category=10th&qualification=10th&'; }
            else if (filterQualification === '12th') { url += 'category=10th&qualification=12th&'; }
            else if (filterQualification === 'graduation') { url += 'category=10th&qualification=graduation&'; }
            else if (filterQualification === 'iti') { url += 'category=iti&'; }
            else if (filterQualification === 'diploma') { url += 'category=diploma&'; }

            if (filterDistrict !== 'all') url += `district=${filterDistrict}&`;
            if (filterAge === 'under18') url += 'age_max=17&';
            if (filterAge === '18-25') url += 'age_min=18&age_max=25&';
            if (filterAge === '26-35') url += 'age_min=26&age_max=35&';
            if (filterAge === '35+') url += 'age_min=36&';
            if (filterBranch !== 'all') url += `branch=${encodeURIComponent(filterBranch)}&`;
            if (filterMonth !== 'all') url += `month=${filterMonth}&`;
            if (filterExperience !== 'all') url += `experience=${filterExperience}&`;
            if (filterJoining !== 'all') url += `joining=${filterJoining}&`;

            const res = await fetch(url, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            setStudents(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error('Students fetch error:', err);
        }
    };

    const deleteStudent = async (id) => {
        if (!window.confirm('Kya aap is student ka data delete karna chahte hain?')) return;
        try {
            const token = localStorage.getItem('adminToken');
            await fetch(`http://localhost:5000/api/dashboard/students/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setStudents(prev => prev.filter(s => s.id !== id));
        } catch (err) {
            alert('Delete nahi hua. Dobara try karo.');
        }
    };

    useEffect(() => {
        if (!localStorage.getItem('adminToken')) {
            navigate('/jf-secure-2024');
            return;
        }
        fetchStats();
    }, [navigate]);

    useEffect(() => {
        if (activeTab === 'students') fetchStudents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, filterQualification, filterDistrict, filterAge, filterBranch, filterMonth, filterExperience, filterJoining]);

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        navigate('/jf-secure-2024');
    };

    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <ul className="flex flex-wrap justify-center gap-2 mt-3">
                {payload.map((entry, i) => (
                    <li key={i} className="flex items-center gap-1 text-xs text-gray-300">
                        <span style={{ background: entry.color }} className="inline-block w-3 h-3 rounded-full flex-shrink-0" />
                        {entry.value}
                    </li>
                ))}
            </ul>
        );
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className="bg-dark-300 border border-gray-700 rounded-xl px-4 py-2 text-sm">
                    <p className="text-white font-semibold">{payload[0].name}</p>
                    <p className="text-saffron-500">{payload[0].value} students</p>
                </div>
            );
        }
        return null;
    };

    const monthTrend = thisMonth >= lastMonth ? '↑' : '↓';
    const monthColor = thisMonth >= lastMonth ? 'text-green-400' : 'text-red-400';
    const showBranch = ['iti', 'diploma', 'all'].includes(filterQualification);

    return (
        <main className="bg-dark-300 min-h-screen">

            {/* ── TOP BAR ── */}
            <div className="bg-dark-200 border-b border-gray-800 px-6 py-4 flex justify-between items-center">
                <span className="text-saffron-500 font-display text-xl font-bold">
                    Job<span className="text-white">Freedom</span>
                    <span className="text-gray-500 text-sm font-sans ml-3">Admin Panel</span>
                </span>
                <button onClick={handleLogout} className="text-gray-400 hover:text-red-400 text-sm transition">
                    Logout →
                </button>
            </div>

            <div className="max-w-7xl mx-auto px-4 py-8">

                {/* ── STATS CARDS ── */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                    <div className="bg-dark-200 border border-gray-800 rounded-2xl p-5">
                        <div className="text-3xl mb-2">👥</div>
                        <div className="text-saffron-500 font-display text-2xl font-bold">{totalStudents.toLocaleString()}</div>
                        <div className="text-gray-500 text-sm mt-1">Total Students</div>
                    </div>
                    <div className="bg-dark-200 border border-gray-800 rounded-2xl p-5">
                        <div className="text-3xl mb-2">💰</div>
                        <div className="text-saffron-500 font-display text-2xl font-bold">₹{totalRevenue.toLocaleString()}</div>
                        <div className="text-gray-500 text-sm mt-1">Total Revenue</div>
                    </div>
                    <div className="bg-dark-200 border border-gray-800 rounded-2xl p-5">
                        <div className="text-3xl mb-2">📅</div>
                        <div className="flex items-end gap-2">
                            <div className="text-saffron-500 font-display text-2xl font-bold">{thisMonth}</div>
                            <span className={`text-xs font-semibold mb-1 ${monthColor}`}>
                                {monthTrend} last month ({lastMonth})
                            </span>
                        </div>
                        <div className="text-gray-500 text-sm mt-1">This Month</div>
                    </div>
                    <div className="bg-dark-200 border border-gray-800 rounded-2xl p-5">
                        <div className="text-3xl mb-2">🏭</div>
                        <div className="text-saffron-500 font-display text-2xl font-bold">6</div>
                        <div className="text-gray-500 text-sm mt-1">Contractors</div>
                    </div>
                </div>

                {/* ── TABS ── */}
                <div className="flex gap-2 mb-8 flex-wrap">
                    {['overview', 'students', 'feedback', 'contacts'].map(tab => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`px-6 py-2 rounded-full text-sm font-semibold transition capitalize ${activeTab === tab
                                ? 'bg-saffron-500 text-white'
                                : 'bg-dark-200 text-gray-400 hover:text-white border border-gray-800'
                                }`}
                        >
                            {tab === 'overview' ? '📊 Overview' :
                                tab === 'students' ? '👥 Students' :
                                    tab === 'feedback' ? '⭐ Feedback' : '📩 Contacts'}
                        </button>
                    ))}
                </div>

                {/* ── OVERVIEW TAB ── */}
                {activeTab === 'overview' && (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {[
                            { title: 'Category Wise', data: categoryData },
                            { title: 'Age Wise', data: ageData },
                            { title: 'District Wise', data: districtData },
                        ].map((chart, idx) => (
                            <div key={idx} className="bg-dark-200 border border-gray-800 rounded-2xl p-6">
                                <h3 className="text-white font-semibold mb-4">{chart.title}</h3>
                                {chart.data.length === 0 ? (
                                    <p className="text-gray-500 text-sm text-center py-10">Data nahi hai abhi</p>
                                ) : (
                                    <ResponsiveContainer width="100%" height={260}>
                                        <PieChart>
                                            <Pie
                                                data={chart.data}
                                                cx="50%" cy="45%"
                                                outerRadius={85} innerRadius={40}
                                                dataKey="value"
                                                label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                                                labelLine={false}
                                            >
                                                {chart.data.map((entry, i) => (
                                                    <Cell key={i} fill={entry.color} stroke="transparent" />
                                                ))}
                                            </Pie>
                                            <Tooltip content={<CustomTooltip />} />
                                            <Legend content={renderLegend} />
                                        </PieChart>
                                    </ResponsiveContainer>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {/* ── STUDENTS TAB ── */}
                {activeTab === 'students' && (
                    <div>
                        <div className="flex flex-wrap gap-3 mb-6">
                            <select value={filterQualification} onChange={e => setFilterQualification(e.target.value)}
                                className="bg-dark-200 border border-gray-700 text-white rounded-xl px-4 py-2 outline-none text-sm">
                                <option value="all">All Students</option>
                                <option value="10th">10th Pass</option>
                                <option value="12th">12th Pass</option>
                                <option value="graduation">BA Graduation</option>
                                <option value="iti">ITI</option>
                                <option value="diploma">Diploma / B.Tech</option>
                            </select>

                            <select value={filterDistrict} onChange={e => setFilterDistrict(e.target.value)}
                                className="bg-dark-200 border border-gray-700 text-white rounded-xl px-4 py-2 outline-none text-sm">
                                <option value="all">All Districts</option>
                                {[
                                    'Araria', 'Arwal', 'Aurangabad', 'Banka', 'Begusarai',
                                    'Bhagalpur', 'Bhojpur', 'Buxar', 'Darbhanga', 'East Champaran',
                                    'Gaya', 'Gopalganj', 'Jamui', 'Jehanabad', 'Kaimur',
                                    'Katihar', 'Khagaria', 'Kishanganj', 'Lakhisarai', 'Madhepura',
                                    'Madhubani', 'Munger', 'Muzaffarpur', 'Nalanda', 'Nawada',
                                    'Patna', 'Purnia', 'Rohtas', 'Saharsa', 'Samastipur',
                                    'Saran', 'Sheikhpura', 'Sheohar', 'Sitamarhi', 'Siwan',
                                    'Supaul', 'Vaishali', 'West Champaran'
                                ].map(d => (
                                    <option key={d} value={d}>{d}</option>
                                ))}
                            </select>

                            <select value={filterAge} onChange={e => setFilterAge(e.target.value)}
                                className="bg-dark-200 border border-gray-700 text-white rounded-xl px-4 py-2 outline-none text-sm">
                                <option value="all">All Ages</option>
                                <option value="under18">Under 18</option>
                                <option value="18-25">18 - 25</option>
                                <option value="26-35">26 - 35</option>
                                <option value="35+">35+</option>
                            </select>

                            {showBranch && (
                                <select value={filterBranch} onChange={e => setFilterBranch(e.target.value)}
                                    className="bg-dark-200 border border-gray-700 text-white rounded-xl px-4 py-2 outline-none text-sm">
                                    <option value="all">All Branches</option>
                                    <optgroup label="── ITI ──">
                                        <option value="ITI Electrician">ITI Electrician</option>
                                        <option value="ITI Welder">ITI Welder</option>
                                        <option value="ITI Fitter">ITI Fitter</option>
                                    </optgroup>
                                    <optgroup label="── Diploma ──">
                                        <option value="Diploma Mechanical">Diploma Mechanical</option>
                                        <option value="Diploma Electrical">Diploma Electrical</option>
                                        <option value="Diploma Electronics">Diploma Electronics</option>
                                    </optgroup>
                                    <optgroup label="── B.Tech ──">
                                        <option value="B.Tech Mechanical">B.Tech Mechanical</option>
                                        <option value="B.Tech Electrical">B.Tech Electrical</option>
                                        <option value="B.Tech EEE">B.Tech EEE</option>
                                    </optgroup>
                                </select>
                            )}

                            <select value={filterMonth} onChange={e => setFilterMonth(e.target.value)}
                                className="bg-dark-200 border border-gray-700 text-white rounded-xl px-4 py-2 outline-none text-sm">
                                <option value="all">All Months</option>
                                {MONTHS.map((m, i) => (
                                    <option key={i} value={i + 1}>{m}</option>
                                ))}
                            </select>

                            <select value={filterExperience} onChange={e => setFilterExperience(e.target.value)}
                                className="bg-dark-200 border border-gray-700 text-white rounded-xl px-4 py-2 outline-none text-sm">
                                <option value="all">All (Fresher + Experienced)</option>
                                <option value="fresher">Fresher</option>
                                <option value="experienced">Experienced</option>
                            </select>

                            <select
                                value={filterJoining}
                                onChange={e => setFilterJoining(e.target.value)}
                                className="bg-dark-200 border border-gray-700 text-white rounded-xl px-4 py-2 outline-none text-sm"
                            >
                                <option value="all">All Joining</option>
                                <option value="immediate">Jaldi Join</option>
                                <option value="3days">3 Din Baad</option>
                                <option value="1week">1 Week Baad</option>
                            </select>

                            <span className="text-gray-500 text-sm self-center">{students.length} students found</span>
                        </div>

                        <div className="bg-dark-200 border border-gray-800 rounded-2xl overflow-x-auto">
                            <table className="w-full text-sm">
                                <thead>
                                    <tr className="border-b border-gray-800">
                                        {['#', 'Name', 'Phone', 'Age', 'District', 'Category', 'Qualification', 'Branch', 'Experience', 'Passing Year', 'Payment ID', 'Date', 'Action'].map(h => (
                                            <th key={h} className="text-gray-400 font-medium text-left px-4 py-4">{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {students.length === 0 ? (
                                        <tr><td colSpan="13" className="text-center text-gray-500 py-10">Koi student nahi mila</td></tr>
                                    ) : (
                                        students.map((s, i) => (
                                            <tr key={s.id} className="border-b border-gray-800 hover:bg-dark-300 transition">
                                                <td className="px-4 py-4 text-gray-500">{i + 1}</td>
                                                <td className="px-4 py-4 text-white font-medium">{s.name}</td>
                                                <td className="px-4 py-4 text-gray-400">{s.phone}</td>
                                                <td className="px-4 py-4 text-gray-400">{s.age}</td>
                                                <td className="px-4 py-4 text-gray-400">{s.district}</td>
                                                <td className="px-4 py-4">
                                                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${s.category === '10th' ? 'bg-saffron-500/20 text-saffron-400' :
                                                        s.category === 'iti' ? 'bg-blue-500/20 text-blue-400' :
                                                            'bg-green-500/20 text-green-400'
                                                        }`}>{s.category.toUpperCase()}</span>
                                                </td>
                                                <td className="px-4 py-4 text-gray-400">
                                                    {s.form_data?.qualification
                                                        ? ({ '10th': '10th Pass', '12th': '12th Pass', 'graduation': 'BA Graduation' }[s.form_data.qualification] || s.form_data.qualification)
                                                        : '—'}
                                                </td>
                                                <td className="px-4 py-4 text-gray-400">{s.form_data?.trade || s.form_data?.branch || '—'}</td>
                                                <td className="px-4 py-4">
                                                    {s.form_data?.experience ? (
                                                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${s.form_data.experience === 'fresher'
                                                            ? 'bg-purple-500/20 text-purple-400'
                                                            : 'bg-yellow-500/20 text-yellow-400'
                                                            }`}>
                                                            {s.form_data.experience === 'fresher' ? 'Fresher' : 'Experienced'}
                                                        </span>
                                                    ) : '—'}
                                                </td>
                                                <td className="px-4 py-4 text-gray-400">{s.form_data?.year || '—'}</td>
                                                <td className="px-4 py-4 text-gray-400 text-xs">{s.payment_id || '—'}</td>
                                                <td className="px-4 py-4 text-gray-500">{new Date(s.created_at).toLocaleDateString('en-IN')}</td>
                                                <td className="px-4 py-4 text-gray-400">
                                                    {s.form_data?.joining === 'immediate' ? '⚡ Jaldi Join' :
                                                        s.form_data?.joining === '3days' ? '📅 3 Din Baad' :
                                                            s.form_data?.joining === '1week' ? '🗓️ 1 Week Baad' : '—'}
                                                </td>
                                                <td className="px-4 py-4">
                                                    <button onClick={() => deleteStudent(s.id)}
                                                        className="bg-red-500/20 hover:bg-red-500/40 text-red-400 text-xs px-3 py-1 rounded-full transition">
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {/* ── FEEDBACK TAB ── */}
                {activeTab === 'feedback' && (
                    <FeedbackTab token={localStorage.getItem('adminToken')} />
                )}

                {/* ── CONTACTS TAB ── */}
                {activeTab === 'contacts' && (
                    <ContactsTab token={localStorage.getItem('adminToken')} />
                )}

            </div>
        </main>
    );
}

export default AdminDashboard;